(() => {
  if (customElements.get('moebe-text-columns')) return;
  class MoebeTextColumns extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.mobile = window.matchMedia('(max-width: 768px)');
      this.track = this.querySelector('.text-columns__track');
      this.list = this.querySelector('.text-columns__grid');
      this.columns = Array.from(this.querySelectorAll('.text-columns__column'));
      this.mobile.addEventListener('change', () => this.update(), {signal});
      document.addEventListener('shopify:block:select', event => {
        const index = this.columns.findIndex(column => column.dataset.columnBlock === event.detail.blockId);
        if (this.carousel && index >= 0) this.carousel.go(index);
      }, {signal});
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.update(), {once: true, signal});
      else this.update();
    }
    update() {
      const enabled = this.dataset.mobileCarousel === 'true' && this.mobile.matches && this.columns.length > 1;
      if (!enabled) { this.destroyCarousel(); return; }
      if (this.carousel || typeof window.Splide !== 'function') return;
      this.classList.add('splide', 'is-mobile-carousel');
      this.track.classList.add('splide__track');
      this.list.classList.add('splide__list');
      this.columns.forEach(column => column.classList.add('splide__slide'));
      this.carousel = new window.Splide(this, {type: 'slide', perPage: 1, perMove: 1, arrows: false, pagination: true, autoplay: false, speed: 300, rewind: false, drag: true, keyboard: 'focused', paginationKeyboard: true});
      this.carousel.mount();
    }
    destroyCarousel() {
      if (!this.carousel) return;
      this.carousel.destroy(true);
      this.carousel = null;
      this.classList.remove('splide', 'is-mobile-carousel');
      this.track.classList.remove('splide__track');
      this.list.classList.remove('splide__list');
      this.columns.forEach(column => column.classList.remove('splide__slide'));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.destroyCarousel();
    }
  }
  customElements.define('moebe-text-columns', MoebeTextColumns);
})();
